/**
 * Awaits every route-scoped component chunk and reports the ones that failed,
 * without letting a failure propagate.
 *
 * The returned promise always fulfils. A page gates Alpine's start on it, and a
 * chunk that 404s — a hashed asset purged by a deploy, a dropped CDN request —
 * must cost only the components it carried. A propagating rejection would leave
 * the page with no Alpine component at all: menus, modals and inline editors
 * inert, with no error UI (Sentry LEGACY-Q95N: "ChunkLoadError: Loading chunk
 * 297 failed").
 *
 * @param {Array<{names: string[], promise: Promise}>} components
 * @param {function(*, string[]): void} onFailure Receives the rejection reason
 *        and the component names that chunk was carrying.
 * @returns {Promise<void>}
 */
export function settleLazyComponents(components, onFailure) {
    return Promise.allSettled(components.map((component) => component.promise))
        .then((results) => {
            results.forEach((result, index) => {
                if (result.status !== 'rejected') {
                    return;
                }

                try {
                    onFailure(result.reason, components[index].names);
                } catch (error) {
                    // One chunk's handling must not skip the rest, and the outer
                    // settle would otherwise absorb this without a trace.
                    console.error('[settle-lazy-components] failure handler threw:', error);
                }
            });
        });
}
